import React, { FC } from "react";
import { Card, Container } from "@mui/material";
import { Form, FormikValues, useFormikContext } from "formik";

import Button from "../../../common/Button";
import InputField from "../../../common/form/input/InputField";
import styles from "../login.module.scss";
import IMAGES from "../../../../assets/themes/images/images";
import { useNavigate } from "react-router-dom";

const ForgetPasswordForm: FC = () => {
  const navigate = useNavigate();
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
  };

  const navigateToPrevPage = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Form className={`${styles.loginWrap} ${styles.formSpaceTop}`}>
        <>
          <div className={styles.logoWrap}>
            <img className={styles.logoLogin} src={IMAGES.Logo} alt="logo" />
          </div>
          <Card className={styles.loginCard} variant="outlined">
            <div className={styles.cardBody}>
              <div className={`text-center ${styles.headerTop}`}>
                <h2 className="font-weight-semi-bold mb-1">
                  Forgot Password ?
                </h2>
                <p className="font-size-18">
                  Enter your email to reset your password.
                </p>
              </div>
              <div className="form-group">
                <label className="mb-1 font-size-14 font-weight-medium">
                  Email
                </label>
                <InputField
                  type="text"
                  className="form-control"
                  name="email"
                  placeholder="admin@example.com"
                  value={values?.email}
                  onChange={inputHandler}
                />
              </div>
              <div
                className={`d-flex justify-content-center ${styles.loginFooter}`}
              >
                <Button color="alert" type="submit" className="mr-12">
                  Submit
                </Button>
                <Button
                  color="default"
                  type="button"
                  onClick={navigateToPrevPage}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Card>
        </>
      </Form>
    </Container>
  );
};

export default ForgetPasswordForm;
